import { ArrowUpRight, Heart } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";

export const ReelDialog = ({ reel, onClose }) => (
  <Dialog open={!!reel} onOpenChange={(o) => { if (!o) onClose(); }}>
    <DialogContent className="max-w-3xl p-0 rounded-none border-stone-200 bg-[#FBFBF9] overflow-hidden max-h-[92vh] overflow-y-auto" data-testid="reel-dialog">
      {reel && (
        <div className="grid md:grid-cols-5">
          <div className="md:col-span-3 bg-stone-900 flex items-center justify-center">
            <iframe
              key={reel.code}
              src={reel.embed}
              title={reel.title}
              className="w-full h-[70vh] md:h-[80vh] border-0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
              data-testid="reel-dialog-iframe"
            />
          </div>
          <div className="md:col-span-2 p-8 flex flex-col">
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#B85C38]">{reel.tag} · {reel.date}</p>
            <DialogTitle className="font-serif font-light text-3xl text-stone-900 mt-3" data-testid="reel-dialog-title">{reel.title}</DialogTitle>
            <DialogDescription className="mt-4 flex items-center gap-2 font-mono text-sm text-stone-600"><Heart size={14} className="fill-stone-600" /> {reel.likes} likes on Instagram</DialogDescription>
            <p className="mt-6 text-stone-600 font-light leading-relaxed text-sm">If the video does not load here, open it directly on Instagram.</p>
            <a href={reel.url} target="_blank" rel="noopener noreferrer" className="btn-ghost mt-8 self-start" data-testid="reel-dialog-open-btn">Open on Instagram <ArrowUpRight size={16} /></a>
            <a href="/contact" onClick={onClose} className="btn-dark mt-3 self-start" data-testid="reel-dialog-enquire-btn">Start your project</a>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
